var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getCurrentQuestionAnswer from '../../../../helpers/getCurrentQuestionAnswer';
import { FieldType } from '../../../../redux/questionnaire/typings';
import { updateAdditionalFieldFormError, updateFormError } from '../../../../redux/ui/ui.slice';
import { t } from '../../../../strings/i18n/i18n';
export var validateFormError = function (fieldType, isAdditionalFieldFormError, formError) {
    return function (dispatch) {
        if (isAdditionalFieldFormError) {
            return dispatch(updateAdditionalFieldFormError(formError));
        }
        if (formError) {
            return dispatch(updateFormError(formError));
        }
        switch (fieldType) {
            case FieldType.Date:
                return dispatch(updateFormError(t('formError.pleaseSelectDate')));
            case FieldType.TextArea:
            case FieldType.TextBox:
                return dispatch(updateFormError(t('formError.pleaseAnswer')));
            case FieldType.TableList:
                return dispatch(updateFormError(t('formError.pleaseSelectAdditionalTransactions')));
            case FieldType.Chips:
            case FieldType.DropDown:
            case FieldType.PopUp:
            case FieldType.Radio:
            case FieldType.Text:
            default:
                return dispatch(updateFormError());
        }
    };
};
export var validateAdditionalContent = function (_a) {
    var _b;
    var _c, _d;
    var userAnswers = _a.userAnswers, currentQuestion = _a.currentQuestion;
    var validationResult = {
        isAdditionalContent: false,
        errorMessage: ''
    };
    var selectedAnswer;
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var currentAnswer = currentQuestion.answers[0];
    var answerOptions = currentAnswer.answerOptions, fieldType = currentAnswer.fieldType;
    if (fieldType === FieldType.TableList) {
        return {
            isAdditionalContent: false,
            errorMessage: ''
        };
    }
    if (fieldType === FieldType.Date) {
        selectedAnswer = answerOptions === null || answerOptions === void 0 ? void 0 : answerOptions[0];
    }
    else {
        selectedAnswer = answerOptions.find(function (answer) { return answer.answerOption === currentQuestionAnswer.answers[0]; });
    }
    validationResult.isAdditionalContent =
        (selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.additionalContent) &&
            (selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.metadata[0].fieldType) !== FieldType.Text;
    if ((selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.additionalContent) && !currentQuestionAnswer.answers[1]) {
        var errorMessages = (_b = {},
            _b[FieldType.TextBox] = t('formError.pleaseAnswer'),
            _b[FieldType.Date] = t('formError.pleaseSelectDate'),
            _b);
        var metadataFieldType = (_d = (_c = selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.metadata) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.fieldType;
        validationResult = __assign(__assign({}, validationResult), { errorMessage: errorMessages[metadataFieldType] || '' });
    }
    return validationResult;
};
//# sourceMappingURL=validationHelper.js.map